import { createRoutine } from '@skunexus/utils';

const prefix = 'PURCHASE_ORDER_OVERVIEW_MODULE';

export const repushOrder = createRoutine(`${prefix}/REPUSH_ORDER`);
